<template>
    <BButton id="btn-copy-item" v-bind="$attrs" @click="cloneItem">
        <slot>Copy</slot>
    </BButton>
</template>

<script>
import { BButton } from "bootstrap-vue";
import { cloneItem } from "../../schema/schema_utils.js";

export default {
    name: "OCopyItemButton",
    components: {
        BButton,
    },
    model: {
        prop: "value",
        event: "changed",
    },
    props: {
        /* Name the model for the Item */
        modelName: { type: String, required: true },

        /* The Item to clone */
        value: { type: Object, required: true },
    },
    methods: {
        cloneItem() {
            var newItem = cloneItem(this.value, this.modelName);

            this.$emit("changed", newItem);
        },
    },
};
</script>

<style scoped></style>
